import React, { useState } from 'react';
import { Mail, Lock, Eye, EyeOff, ArrowRight, AlertCircle, Briefcase, User } from 'lucide-react';
type Props = {
  onLogin: (role: 'operator' | 'client', email: string) => void;
};
export function Login({
  onLogin
}: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const normalized = email.trim().toLowerCase();
    if (!normalized || !password) {
      setError('Inserisci email e password.');
      return;
    }
    if (normalized === 'admin@aisac.io') {
      setSubmitting(true);
      setTimeout(() => onLogin('operator', normalized), 350);
      return;
    }
    if (normalized === 'customer@aisac.io') {
      setSubmitting(true);
      setTimeout(() => onLogin('client', normalized), 350);
      return;
    }
    setError('Email non riconosciuta. Prova admin@aisac.io o customer@aisac.io.');
  };
  const fill = (value: string) => {
    setEmail(value);
    setPassword('demo');
    setError(null);
  };
  return <div className="dark min-h-screen w-full bg-[#0A0A0A] text-[#FAFAFA] font-heading antialiased flex items-center justify-center px-4 py-8" data-id="element-777">
      <div className="w-full max-w-[400px]" data-id="element-778">
        <div className="flex justify-center mb-10" data-id="element-779">
          <img src="https://cdn.magicpatterns.com/uploads/ufiC3EWUw7dMTCsenDXGVj/4_6021369468377112115.svg" alt="Aisac" className="h-9 w-auto" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-780" />
        </div>

        <div className="bg-[#181818] border border-[#262626] rounded-2xl p-6 sm:p-8" data-id="element-781">
          <div className="mb-6" data-id="element-782">
            <h1 className="text-xl font-semibold text-[#FAFAFA] font-heading" data-id="element-783">
              Accedi
            </h1>
            <p className="text-sm text-[#9A9A9A] mt-1" data-id="element-784">
              Entra nel tuo spazio Aisac.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-785">
            <div data-id="element-786">
              <label htmlFor="email" className="block text-[11px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-1.5" data-id="element-787">
                Email
              </label>
              <div className="relative" data-id="element-788">
                <Mail className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-789" />
                <input id="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="nome@aisac.io" className="w-full pl-9 pr-3 py-2.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30 focus:border-[#333]" data-id="element-790" />
              </div>
            </div>

            <div data-id="element-791">
              <div className="flex items-center justify-between mb-1.5" data-id="element-792">
                <label htmlFor="password" className="block text-[11px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-793">
                  Password
                </label>
                <button type="button" className="text-[11px] text-[#9A9A9A] hover:text-[#FAFAFA] transition-colors" data-id="element-794">
                  Password dimenticata?
                </button>
              </div>
              <div className="relative" data-id="element-795">
                <Lock className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-796" />
                <input id="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full pl-9 pr-10 py-2.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30 focus:border-[#333]" data-id="element-797" />
                <button type="button" onClick={() => setShowPassword(v => !v)} aria-label={showPassword ? 'Nascondi password' : 'Mostra password'} className="absolute right-2.5 top-1/2 -translate-y-1/2 h-7 w-7 rounded flex items-center justify-center text-[#6B6B6B] hover:text-[#FAFAFA] transition-colors" data-id="element-798">
                  {showPassword ? <EyeOff className="h-4 w-4" data-id="element-799" /> : <Eye className="h-4 w-4" data-id="element-800" />}
                </button>
              </div>
            </div>

            {error && <div className="flex items-start gap-2 px-3 py-2 rounded-lg bg-[#EF4444]/10 border border-[#EF4444]/30 text-[#EF4444] text-xs" data-id="element-801">
                <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" data-id="element-802" />
                <span data-id="element-803">{error}</span>
              </div>}

            <button type="submit" disabled={submitting} className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/40 transition disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-804">
              <span data-id="element-805">{submitting ? 'Accesso in corso...' : 'Accedi'}</span>
              {!submitting && <ArrowRight className="h-4 w-4" data-id="element-806" />}
            </button>
          </form>

          <div className="mt-6 pt-5 border-t border-[#262626]" data-id="element-807">
            <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-2" data-id="element-808">
              Account demo
            </div>
            <div className="space-y-1.5" data-id="element-809">
              <button type="button" onClick={() => fill('admin@aisac.io')} className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg bg-[#0A0A0A] border border-[#262626] hover:border-[#333] text-left transition" data-id="element-810">
                <Briefcase className="h-4 w-4 text-[#9A9A9A] shrink-0" data-id="element-811" />
                <span className="text-sm text-[#FAFAFA] font-medium" data-id="element-812">
                  Vista Admin
                </span>
              </button>
              <button type="button" onClick={() => fill('customer@aisac.io')} className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg bg-[#0A0A0A] border border-[#262626] hover:border-[#333] text-left transition" data-id="element-813">
                <User className="h-4 w-4 text-[#9A9A9A] shrink-0" data-id="element-814" />
                <span className="text-sm text-[#FAFAFA] font-medium" data-id="element-815">
                  Vista Customer
                </span>
              </button>
            </div>
          </div>
        </div>

        <p className="text-center text-[11px] text-[#6B6B6B] mt-6" data-id="element-816">
          Aisac © 2026 · Piattaforma logistica
        </p>
      </div>
    </div>;
}